/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.large-image {
  }

  &.single-item {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    align-items: center;

    &.left,
    &.Left {
      flex-direction: row;
    }

    &.right,
    &.Right {
      flex-direction: row-reverse;
    }

    &.reduce-margin-between-items {
      margin: 0;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  /* for IE */
  /* width: 100%; */
  width: auto;
  max-width: 100%;

  h2,
  h3 {
    margin-bottom: 20px;
  }

  h3 {
    font-weight: 700;
    /* for IE */
    width: 100%;
  }

  p {
    margin-bottom: 10px;
    /* for IE */
    width: 100%;
  }

  ${Block}.single-item & {
    
  }

  ${Block}.single-item & {
    p {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: -0.41px;
      line-height: 24px;
    }
  }

  ${Block}.single-item & {
    align-items: center;
    text-align: center;

    h2,
    h3 {
      width: 100%;
    }
  }
  
  ul {
    /* FOR IE */
    width: 100%
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Block}.large-image & {
      padding: 50px 0px 0 70px;
    }

    ${Block}.large-image.right &, ${Block}.large-image.Right & {
      padding: 20px 70px 0 0px;
    }

    ${Block}.single-item & {
      align-items: flex-start;
      text-align: left;

      h2,
      h3 {
        width: auto;
      }

      p {
        font-size: 22px;
        font-weight: 600;
        letter-spacing: -0.5px;
        line-height: 38px;
      }
    }

    h2,
    h3 {
      text-align: left;
    }

    ${Block}.right &, ${Block}.Right & {
      /* padding-left: 90px;
      padding-right: 0; */
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 0px 90px 0 0;

    h2,
    h3 {
      text-align: left;
    }

    ${Block}.right &, ${Block}.Right & {
      padding-left: 90px;
      padding-right: 0;
    }

    ${Block}.large-image & {
      padding: 0px 90px 0 70px;
    }

    ${Block}.large-image.right &, ${Block}.large-image.Right & {
      padding: 0px 70px 0 90px;
    }
  }
`;

export const StyledImage = styled(Image)`
  height: 100%;
  width: 100%;
  max-height: 180px;
  max-width: 180px;
  object-fit: contain;
  margin: 0 auto 20px;
  /* for IE */
  flex-shrink: 0;

  ${Block}.large-image & {
    height: auto;
    max-height: 100%;
    width: 100%;
    max-width: 380px;
  }

  ${Block}.single-item & {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Block}.single-item & {
      max-height: 210px;
      max-width: 210px;
      margin: 0 auto 40px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 210px;
    max-width: 210px;
    margin: 0 72px 0 0;
    margin-right: px;
    
    ${Block}.right &, ${Block}.Right & {
      margin: 0 0 0 72px;
    }

    ${Block}.large-image & {
      margin: 0;
    }

    ${Block}.single-item & {
      max-height: 360px;
      max-width: 360px;
      margin: 0 72px 0 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    max-height: 360px;
    max-width: 360px;

    ${Block}.large-image & {
      max-height: 420px;
      max-width: 640px;
    }
  }
`;

export const StyledLink = styled(Link)`
  margin-top: 50px;

  align-self: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    align-self: flex-start;
    margin-top: 70px;
  }
`;
